/**
 * Trade-related constants for price buffers and order logic
 */

/**
 * Price buffer percentages for different order types
 */
export const PRICE_BUFFERS = {
	/** 1% default buffer for limit orders and trigger orders */
	DEFAULT_FRACTION: 0.01,
	/** 10% default buffer for scaled orders */
	SCALED_ORDERS_FRACTION: 0.1,
	/** 0.99% buffer for trigger warning calculations to avoid false warnings with 1% default */
	TRIGGER_WARNING_PCT: 0.99,
} as const;

export const TRADE_PAGE_CHART_DEFAULT_HEIGHT = 450;
export const TRADE_PAGE_CHART_HEIGHT_KEY = 'tradePageChartHeight';

/**
 * Buffer denominator for isolated position deposits.
 * The buffer is calculated as: marginRequired / ISOLATED_POSITION_DEPOSIT_BUFFER_DENOMINATOR
 * 15 -> 6.67% buffer, 20 -> 5% buffer, 10 -> 10% buffer
 */
export const ISOLATED_POSITION_DEPOSIT_BUFFER_DENOMINATOR = 15;

/**
 * Additional buffer percentage to apply when retrying an isolated position order
 * after an InsufficientCollateral error from Swift.
 * 2 -> 2% additional buffer on retry
 */
export const ISOLATED_POSITION_RETRY_DEPOSIT_BUFFER_PCT = 2;
